module.exports = __webpack_public_path__ + "img/oval_2.ddc810f0.png";